import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { UpgradeDetailsConfig, UpgradesPluginService } from './upgrades-plugin.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    templateUrl: './upgrades.component.html',
    standalone: false
})
export class UpgradesPluginComponent extends BasePlugin implements OnInit {
  plugin: any = {};
  inspectionId: string;
  inspection: Inspection;
  loading = false;
  upgradeDetailsConfig: UpgradeDetailsConfig[];

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private upgradePluginService: UpgradesPluginService
  ) {
    super();
  }

  ngOnInit() { }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.cdRef.detectChanges();
  }

  initData() {
    this.upgradePluginService
      .getUpgradesDetailsConfig(this.inspection.id)
      .subscribe((data) => (this.upgradeDetailsConfig = data));

    if (!this.plugin?.config?.Upgrades?.length) {
      this.loading = true;
      this.upgradePluginService
        .getUpgrades(this.inspection.id, { ignoreLoader: 'true' })
        .pipe(
          switchMap((upgrades) => {
            upgrades.forEach((u) => {
              if (u.Status !== 'already-installed') {
                u.Recommended = true;
              }
            });
            this.plugin.config.Upgrades = upgrades.map((u) => ({ ...u, Data: JSON.stringify(u) }));
            if (this.plugin.config.Upgrades?.length) {
              return this.upgradePluginService.updateUpgrades(
                this.inspection.id,
                this.plugin.id,
                this.plugin.config.Upgrades,
                { ignoreLoader: 'true' }
              );
            }
            return of(null);
          })
        )
        .subscribe(() => {
          this.loading = false;
          this.cdRef.detectChanges();
        });
    }
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'upgrades',
      'edit'
    ];
  }

  openDetails(upgrade: any) {
    this.upgradePluginService.openUpgradeDetails(JSON.parse(upgrade.Data), this.upgradeDetailsConfig);
  }
}

PluginComponent.plugins['upgrades'] = UpgradesPluginComponent;
